/**
 * The packages in `names` that the app's package.json doesn't list.
 *
 * A feature never adds a package itself: a native one changes the build's fingerprint, so every
 * code push after it is refused until a new app build. A feature that needs one checks here and,
 * when any is missing, stays off and says so — the package goes into the base theme instead.
 * An unreadable package.json counts as missing everything.
 */
export function missingPackages(packageJson: string | null | undefined, names: string[]): string[] {
  let pkg: any = null;
  try {
    pkg = typeof packageJson === 'string' ? JSON.parse(packageJson) : null;
  } catch {
    pkg = null;
  }
  const deps = { ...(pkg?.dependencies ?? {}), ...(pkg?.devDependencies ?? {}) };
  return names.filter((name) => !deps[name]);
}
